import { FunctionComponent, ReactNode } from "react";
import "./StatusBadge.scss";

export type StatusTone = "success" | "warn" | "danger" | "info" | "neutral";

/**
 * Mapeia strings de status (em portugues ou ingles) para um tom visual.
 * Estende a mesma logica que estava espalhada em ~9 listagens diferentes.
 */
const STATUS_TONE_MAP: Record<string, StatusTone> = {
    // sucesso (verde)
    success:      "success",
    paid:         "success",
    approved:     "success",
    aprovado:     "success",
    pago:         "success",
    verified:     "success",
    active:       "success",
    ativo:        "success",
    ativa:        "success",
    confirmed:    "success",
    completed:    "success",

    // pendente / processando (amarelo)
    pending:      "warn",
    waiting:      "warn",
    processing:   "warn",
    in_progress:  "warn",
    processando:  "warn",
    pendente:     "warn",

    // erro / bloqueado (magenta)
    blocked:      "danger",
    bloqueado:    "danger",
    cancelled:    "danger",
    canceled:     "danger",
    cancelado:    "danger",
    rejected:     "danger",
    rejeitado:    "danger",
    error:        "danger",
    erro:         "danger",
    inactive:     "danger",
    inativo:      "danger",
    inativa:      "danger",
    failed:       "danger",

    // informativo (ciano)
    info:         "info",
    creation:     "info",
    started:      "info",
    new:          "info",
    novo:         "info",
};

interface StatusBadgeProps {
    /** Status bruto vindo da API (case-insensitive). Ex: "PENDING", "approved", "Bloqueado". */
    status?: string;
    /** Forca um tom especifico (opcional). */
    tone?: StatusTone;
    /** Sobrescreve o label exibido (default: status). */
    label?: ReactNode;
    className?: string;
}

const StatusBadge: FunctionComponent<StatusBadgeProps> = ({
    status,
    tone,
    label,
    className = "",
}) => {
    const key = (status ?? "").toString().trim().toLowerCase().replace(/\s+/g, "_");
    const resolvedTone: StatusTone = tone ?? STATUS_TONE_MAP[key] ?? "neutral";

    return (
        <span className={`status-badge tone-${resolvedTone} ${className}`.trim()}>
            {label ?? status}
        </span>
    );
};

export default StatusBadge;
